import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { InputSwitchAlertApiStyled } from "./styled";
import Switch from "react-switch";
import theme from "styles/theme.json";
import { AlertControl } from "components/Modals/Alert";
import { toast } from "react-toastify";

const InputSwitchAlertApi = ({
  theme_standard,
  theme_blue,
  idUpdate,
  initialParams,
  apiService,
  fieldUpdate,
  disabled,
  onChange,
  value,
  color,
  label,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
    theme_blue: theme_blue,
  });

  const _handleChange = (e) => {
    AlertControl.show({
      title: "ยืนยันการอัพเดต",
      description: "คุณต้องการจะอัพเดตใช่หรือไม่",
      btnLabel1: "ยกเลิก",
      btnLabel2: "ยืนยัน",
      onEvent2: async () => {
        let params = {
          ...initialParams,
          [fieldUpdate]: e,
        };
        let res = await apiService(idUpdate, params);
        if (res && res.status === 200) {
          onChange && onChange(e);
          toast.success("อัพเดตสำเร็จ");
        }
      },
    });
  };

  return (
    <InputSwitchAlertApiStyled>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        <Switch
          disabled={disabled}
          onChange={_handleChange}
          checked={value}
          onColor={color ? color : theme.COLORS.BLUE_3}
        />
      </div>
    </InputSwitchAlertApiStyled>
  );
};

InputSwitchAlertApi.propTypes = {};

export default InputSwitchAlertApi;
